module.exports = __webpack_public_path__ + "media/images/sponsor/young-pin-design-award-16936377402441d1cca3322dbad7d891.png";